export enum DashboardLocalStorageKey {
	DeviceInfo = '[DashboardLocalStorageKey] DeviceInfo',
	MenuItems = '[DashboardLocalStorageKey] MenuItems',
	IsQuickSettingsHidden = '[DashboardLocalStorageKey] IsQuickSettingsHidden',
	MemoryDiskUsage = '[DashboardLocalStorageKey] MemoryDiskUsage',
}
